import { render, staticRenderFns } from "./finalizados.vue?vue&type=template&id=8470272c&"
import script from "./finalizados.vue?vue&type=script&lang=js&"
export * from "./finalizados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports